import type { IconAsset } from '../Icon.types';

const code = (
  <g transform='translate(-157 -1138)'>
    <rect fill='none' height='18' transform='translate(157 1138)' width='18' />
    <g transform='translate(159 1140)'>
      <path d='M0,0H14V14H0Z' fill='none' />
      <path
        d='M7.935,2A5.935,5.935,0,1,0,13.87,7.935,5.937,5.937,0,0,0,7.935,2Zm.593,8.9H7.341V7.341H8.528Zm0-4.748H7.341V4.967H8.528Z'
        fill='currentColor'
        transform='translate(-0.935 -0.935)'
      />
    </g>
  </g>
);

export const infoBadge: IconAsset = {
  bold: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
